module.exports = __webpack_public_path__ + "static/heinz-2adb0312ac3e4b6e97a7c90c12212d18.png";